import { parse } from '@config/theme';
export const block = parse({
  position: 'relative',
  display: 'block',
  width: '100%',
  p: {
    _: '6',
    sm: '8'
  }
}, "b1tsxnsq");
export const heading = parse({
  mb: '4'
});
export const text = "t1ls1hzu";
export const grid = parse({
  display: 'grid',
  mt: {
    _: '8',
    sm: '10',
    md: '12',
    xl: '14'
  }
}, "g18b1rmv");

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");